(function () {
    'use strict';

    angular
        .module('procedureModule')
        .factory('procedureEnums', service);

    service.$inject = [];

    function service() {

        var service = {
            procedureType: {
                CorporateProcedure: 303,
                OperationalProcedure: 304,
                Policy: 302,
                ReferenceDocument: 508,
                TermsofReference: 509,
                TermsofReferenceSteering: 513,
                TermsofReferenceSteeringTemplate: 604,
                TermsofReferenceTemplate: 603
            }
        };

        return service;
    }
})();
